import React from 'react';

import { RandomNameStyles } from './RandomName.styles';

const randomNames = [
  'Lovebug',
  'Sugar Daddy',
  'Daddy',
  'Sweetheart',
  'Darling Dove',
  'Heartthrob',
  'Snuggle Bear',
  'Love Muffin',
  'Romance Guru',
  'Dreamboat',
  'Cupid’s Arrow',
  'Heartthrob',
  'Snugglebear',
  'Romeo',
  'Honey Pie',
  'Lovey Dovey',
  'Cuddle Muffin',
  'Charmcaster',
  'Soulmate',
];

export const RandomName: React.FC<{
  onComplete: (name: string) => void;
}> = ({ onComplete }) => {
  const handleClick = () => {
    const randomIndex = Math.floor(Math.random() * randomNames.length);
    const randomName = randomNames[randomIndex];
    onComplete(randomName);
  };

  return (
    <RandomNameStyles
      onTouchStart={(e: React.TouchEvent<HTMLButtonElement>) => {
        e.currentTarget.style.background = '#ffc9fb';
        e.currentTarget.style.color = '#171123';
      }}
      onTouchEnd={(e: React.TouchEvent<HTMLButtonElement>) => {
        e.currentTarget.style.background = '#765279';
        e.currentTarget.style.color = '#fff';
      }}
      onClick={handleClick}
    >
      🎲 Random name
    </RandomNameStyles>
  );
};
